<style lang="less" scoped>
.container {width: 4.98rem; height: 2.92rem;background-image: url('/static/images/szdp/image_frame2.png');display: flex;flex-wrap: wrap;align-content: flex-start;}
.title {width: 100%;height: .4rem;font-size: 14px;font-weight: bold;color: #ffffff;text-align: center;line-height: .42rem;margin: 0;}
.echartsbox {width: 3.8rem;cursor: pointer;}
.elrow {width: 100%;}
.elrowtop {border-bottom: solid 1px #0a64a7}
.contentul {line-height: 0.4rem;}
/deep/.el-col {height: 100%;}
.project {width: 95%;margin-top: .25rem;}
ul{list-style: none;padding: 0;margin: 0;color: #FFF;}
.contentli {text-align: left;width: 100%;}
.contentli span {float: left;font-size: 12px;}
.righttxt {overflow: hidden;text-overflow:ellipsis;white-space: nowrap;color: #00b2f6;width: 70%;}
.lefttxt {color: #06e3f1;width: 30%;}
::-webkit-scrollbar {
  display: none;
}
</style>

<template>
  <div class="container">
    <h1 class="title">矿业项目</h1>
    <div id="Miningproject" class="echartsbox" @click="handleClick()">
      <el-row class="elrow elrowtop">
        <el-col :span="16">
          <ul class="contentul">
            <li class="contentli">
              <span class='lefttxt'>项目名称：</span>
              <span class="righttxt">{{ kyxmData[0].title }}</span>
            </li>
            <li class="contentli">
              <span class='lefttxt'>项目类别：</span>
              <span class="righttxt">{{ kyxmData[0].xiangmuleibie | getKyxmType() }}</span>
            </li>
            <li class="contentli">
              <span class='lefttxt'>合作方式：</span>
              <span class="righttxt">{{ kyxmData[0].hezuofangshi }}</span>
            </li>
          </ul>
        </el-col>
        <el-col :span="8"><img src="/static/images/image_wybh.png" alt="" class="project"></el-col>
      </el-row>
      <el-row class="elrow">
        <el-col :span="16">
          <ul class="contentul">
            <li class="contentli">
              <span class='lefttxt'>项目名称：</span>
              <span class="righttxt">{{ kyxmData[1].title }}</span>
            </li>
            <li class="contentli">
              <span class='lefttxt'>项目类别：</span>
              <span class="righttxt">{{ kyxmData[1].xiangmuleibie | getKyxmType() }}</span>
            </li>
            <li class="contentli">
              <span class='lefttxt'>合作方式：</span>
              <span class="righttxt">{{ kyxmData[1].hezuofangshi }}</span>
            </li>
          </ul>
        </el-col>
        <el-col :span="8"><img src="/static/images/image_wybh.png" alt="" class="project"></el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import filters from '../../method/filter'
export default {
  props: ['kyxmData'],
  mixins: [filters],
  data()
  {
    return {
    }
  },
  methods: {
    handleClick()
    {
      this.$router.push({path: '/HzxmKYXMList'})
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/plugins/app/assembly/DigitalScreen/Kyxm.vue